import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon, FlameIcon, GiftIcon, ArrowRightIcon, TicketIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonuses, idealFor, offerIncludes } from '../data/system';
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta crédito/débito'
}, {
  icon: SmartphoneIcon,
  label: 'Android e iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precio" className="scroll-mt-12 bg-obsidian text-white" data-id="element-185" data-mp="25s7vv92loy1g">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "21px"
    }} data-id="element-186" data-mp="20t4qfnipkpsy">
        <div className="mx-auto max-w-xl text-center" data-id="element-187" data-mp="3h6v67rj6x2if">
          <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/40 bg-ember/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-ember" data-id="element-188" data-mp="3h5jun5ji6qgr">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-189" data-mp="3vynjyjmxk5d1" /> Oferta por tiempo limitado
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold uppercase leading-none sm:text-4xl" data-id="element-190" data-mp="4rkq1kfpjkz4">
            La oferta promocional finaliza pronto
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-white/65" data-id="element-191" data-mp="erle1joiup9n">
            Una vez finalizada la promoción, el precio volverá a su valor de referencia.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 overflow-hidden rounded-3xl border border-white/10 bg-navy shadow-[0_40px_80px_-40px_rgba(20,125,255,0.45)] lg:grid lg:grid-cols-[1fr_1.05fr]" data-id="element-192" data-mp="3i7is43pt0hd9">
          <div className="border-b border-white/10 p-6 sm:p-8 lg:border-b-0 lg:border-r" style={{
          paddingTop: "0px"
        }} data-id="element-193" data-mp="2zgrc4jbb9spw">
            <h3 className="mt-6 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-194" data-mp="2rf1u00ywfg6s">
              Sistema Triatlón Completo™
            </h3>
            <p className="mt-6 text-xs font-bold uppercase tracking-[0.22em] text-aqua" data-id="element-195" data-mp="3177hoyi4bbg6">Ideal para</p>
            <ul className="mt-3 space-y-2.5" data-id="element-196" data-mp="2w7be30dc1m15">
              {idealFor.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-white/75" data-id="element-197" data-mp="28i0li664yxy3">
                  <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-198" data-mp="23ixh8nxzcvr6" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="p-6 sm:p-8" data-id="element-199" data-mp="2ie3otfcq52mm">
            <div className="flex items-end gap-3" data-id="element-200" data-mp="2dgu0k312mx0d">
              <span className="font-display text-[84px] font-extrabold leading-[0.8]" data-id="element-201" data-mp="2dj6fe7bj8r97">$19</span>
              <span className="pb-1 text-lg font-bold text-white/80" data-id="element-202" data-mp="3txg4j3nlmk13">USD</span>
              <span className="pb-1 text-xl font-medium text-white/35 line-through" data-id="element-203" data-mp="3ovqr5hcwlu9u">$38</span>
            </div>
            <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-204" data-mp="92g0n9zafqb">Pago único · Acceso de por vida</p>
            <p className="mt-1 text-[11px] text-white/45" data-id="element-205" data-mp="5aruye0bndjo">El pago se procesará en tu moneda local.</p>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-206" data-mp="3nh66k6b4bbew">
              Los 6 volúmenes de Sistema Triatlón Completo™
            </p>
            <ul className="mt-3 grid gap-x-4 gap-y-2 sm:grid-cols-2" data-id="element-207" data-mp="j26dkjqbhcq7">
              {offerIncludes.map(f => <li key={f} className="flex items-start gap-2 text-sm leading-snug text-white/85" data-id="element-208" data-mp="nywt95y7m6b3">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-209" data-mp="a7ibt3jyad65" />
                  {f}
                </li>)}
            </ul>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-210" data-mp="11zzdre9k38jw">
              Además, los 4 bonos complementarios
            </p>
            <ul className="mt-3 divide-y divide-white/10 border-y border-white/10" data-id="element-211" data-mp="16rr17fxf0y5t">
              {bonuses.map(b => <li key={b.n} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-212" data-mp="3f5fj8rmtch40">
                  <span className="flex min-w-0 items-center gap-2 text-white/85" data-id="element-213" data-mp="3aaidpuoqspvv">
                    <GiftIcon className="h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-214" data-mp="359ulx6sow50l" />
                    <span className="truncate" data-id="element-215" data-mp="319btpbmvwwxv">{b.title}</span>
                  </span>
                  <span className="whitespace-nowrap text-xs" data-id="element-216" data-mp="1rau25dxb16b">
                    <span className="text-white/35 line-through" data-id="element-217" data-mp="3sz6xuefeir6l">{b.price}</span>{' '}
                    <span className="font-bold text-perf" data-id="element-218" data-mp="3o86zr5ujq32i">GRATIS</span>
                  </span>
                </li>)}
            </ul>

            <p className="mt-5 flex items-center gap-2 rounded-xl border border-perf/25 bg-perf/10 px-4 py-3 text-sm font-semibold text-white" data-id="element-219" data-mp="3k7eok7245o3l">
              <ShieldCheckIcon className="h-5 w-5 shrink-0 text-perf" aria-hidden="true" data-id="element-220" data-mp="kl80b8cs6xqz" />
              Garantía de devolución de 7 días
            </p>

            <div className="mt-6" data-id="element-221" data-mp="1yfwxnqouenre">
              <CTAButton className="max-w-none" data-id="element-222" data-mp="1ygzjvlb8020z">Obtener acceso ahora</CTAButton>
            </div>
            <p className="mt-3 text-center text-xs font-semibold text-perf" data-id="element-223" data-mp="23ehxvq43h7fu">
              Ahorras 19 USD · Precio de lanzamiento limitado
            </p>

            <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-224" data-mp="2cfftpl4dq8nc">
              {trust.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-225" data-mp="2hc6hkumfe8jb">
                  <Icon className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-226" data-mp="2mb9d9ogin2em" />
                  {label}
                </li>)}
            </ul>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-ember" data-id="element-227" data-mp="2v5xgza6g0c1b">
              <TicketIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-228" data-mp="3050kuraosc7p" /> Disponibilidad limitada a este precio
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}